export class CategoryTrendSeries {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "series",
            "baseName": "series",
            "type": "MetricTimeseries",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CategoryTrendSeries.attributeTypeMap;
    }
    constructor() {
    }
}
